import authReducer from './loginReducers'
import blueprintReducers from './blueprintReducers'
import { IZimiState } from '../../types/auth';
import { combineReducers, Reducer } from 'redux'

export const reducer: Reducer<IZimiState> = combineReducers<IZimiState>({ authState: authReducer, blueprintState: blueprintReducers })